import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {ErrorView} from '../Shared/Constants';
import LightNotification from '../assets/lightNotification.svg';

const ErrorClientLocationPopUp = ({data, errorId, isErrorPopUpOpen, closePopUp}) => {
  const [tittleError, setTittleError] = useState(<div />);
  const [messageError, setMessageError] = useState(<div />);
  const [buttonErrorMsg, setButtonErrorMsg] = useState();

  useEffect(() => {
    switch (errorId) {
      case ErrorView.ValidationGuid:
        setTittleError(
          <div className='client-location__error-tittle' dangerouslySetInnerHTML={{__html: data?.errorTittleValidationSession?.value}} />
        );
        setMessageError(
          <div className='client-location__error-msg' dangerouslySetInnerHTML={{__html: data?.errorMsgValidationSession?.value}} />
        );
        setButtonErrorMsg(data?.buttonErrorValidation?.value);
        break;
      case ErrorView.SaveDB:
        setTittleError(
          <div className='client-location__error-tittle' dangerouslySetInnerHTML={{__html: data?.errorTittleVSaveDB?.value}} />
        );
        setMessageError(<div className='client-location__error-msg' dangerouslySetInnerHTML={{__html: data?.errorMsgSaveDB?.value}} />);
        setButtonErrorMsg(data?.buttonErrorSaveDB?.value);

        break;
      case ErrorView.General:
        setTittleError(
          <div className='client-location__error-tittle' dangerouslySetInnerHTML={{__html: data?.errorGeneralTittle?.value}} />
        );
        setMessageError(<div className='client-location__error-msg' dangerouslySetInnerHTML={{__html: data?.errorGeneralMsg?.value}} />);
        setButtonErrorMsg(data?.buttonErrorGeneral?.value);
        break;
      default:
        break;
    }
  }, []);

  return (
    <PopUp showPopUp={isErrorPopUpOpen} onClose={closePopUp} className='client-location__popup'>
      <div className='client-location__errorPopUp'>
        <section className='client-location__error-img'>
          <Image src={LightNotification} alt='פעמון התראה' />
        </section>
        {tittleError}
        {messageError}
        <BtnSubmit text={buttonErrorMsg} onclick={() => closePopUp()} />
      </div>
    </PopUp>
  );
};

export default ErrorClientLocationPopUp;
